<template>
    <v-expansion-panel popout>
        <v-expansion-panel-content>
            <template v-slot:header>
                <div class="primary--text text-uppercase font-weight-bold d-flex justify-space-between">
                    <div>{{itemOuLote.descricao}}
                        <span class="red--text text-capitalize ml-2" style="font-size: 0.8rem; text-transform: capitalize !important; ">
                            {{(itemOuLote.isSituacaoRejeicao ? itemOuLote.situacao : '')}}
                        </span>
                    </div>
                    <span v-if="itemOuLote.totalMensagensNaoLidas > 0" class="p-quantidade-mensagens text-sm-center justify-center">
                        {{itemOuLote.totalMensagensNaoLidas}}
                    </span>
                </div>
            </template>
            <v-list>
                <template v-for="(pessoa, index) in itemOuLote.ranking" class="pa-2">
                    <v-divider :key="index"></v-divider>
<!--                    :inactive="pessoa.status !== 'EM_ANALISE'"-->
                    <v-list-tile :key="pessoa.id" class="py-2" @click="$emit('fornecedorClicked', pessoa)">
                        <v-list-tile-avatar size="30" color="secondary">
                            <span class="white--text title">{{ pessoa.posicao }}°</span>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title class="text-uppercase font-weight-bold" v-html="pessoa.razaoSocial"></v-list-tile-title>
                            <v-list-tile-sub-title class="secondary--text text--lighten-2">
                                {{pessoa.cpfCnpj | cpfCnpjFormatter}}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-icon right size="20">fas fa-chevron-right</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>
                </template>
            </v-list>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
export default {
    name: 'ChatItemLote',
    props: {
        itemOuLote: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped lang="stylus">
    .fornecedor-item:hover
        background-color #EFEFEF

    .p-quantidade-mensagens
        height 25px !important
        width 25px !important
        max-width 25px !important
        border none
        background-color red
        color white
        text-align center !important
        align-content center !important
        font-size 0.7rem
        border-radius 25px
        -webkit-border-radius 25px
</style>